import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '../presentation/providers/theme-provider';
import { AuthProvider } from '../presentation/providers/auth-provider';
import { CatalogProvider } from '../presentation/providers/catalog-provider';
import { PdfViewerProvider } from '../presentation/providers/pdf-viewer-provider';
import { ScrollToTop } from '../presentation/components/navigation/scroll-to-top';
import { AppRoutes } from '../presentation/routes/app-routes';
import { BartechToaster } from '../presentation/components/ui/toaster';
import { makeAuthUseCases } from './factories/auth-dependencies.factory';
import { makeCatalogUseCases } from './factories/catalog-dependencies.factory';

// Inyección de dependencias ensamblada en Composition Root
const authUseCases = makeAuthUseCases();
const catalogUseCases = makeCatalogUseCases();

export const App: React.FC = () => {
  const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || undefined;

  return (
    <ThemeProvider>
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <AuthProvider authUseCases={authUseCases}>
          <CatalogProvider catalogUseCases={catalogUseCases}>
            <PdfViewerProvider>
              <AppRoutes />
              <BartechToaster />
            </PdfViewerProvider>
          </CatalogProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};
